if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.syncSelectedOptions();
      if (this.initialized) return;
      this.initialized = true;

      this.addEventListener("pointerdown", this.handleInteractionStart.bind(this));
      this.addEventListener("click", this.handleInteractionEnd.bind(this));
      this.addEventListener("keydown", this.handleInteractionStart.bind(this));
      this.addEventListener("keyup", this.handleInteractionEnd.bind(this));

      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateSelectedOption(target);
        this.handleInteractionEnd();
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    handleInteractionStart() {
      clearTimeout(this.interactionTimer);
      this.isInteracting = true;
    }

    handleInteractionEnd() {
      clearTimeout(this.interactionTimer);
      this.interactionTimer = setTimeout(() => {
        this.isInteracting = false;
      }, 180);
    }

    syncSelectedOptions() {
      this.querySelectorAll("[data-picker-field]").forEach((field) => {
        const target = field.dataset.pickerField === "select"
          ? field.querySelector("select option:checked:not(:disabled)")
          : field.querySelector("input:checked");

        if (target) this.updateSelectedOption(target);
      });
    }

    updateSelectedOption(target) {
      const field = target.closest("[data-picker-field]");
      if (!field) return;

      field.dataset.selectedValue = target.value || "";

      const selectedLabel = field.querySelector(".option-label--selected");
      if (selectedLabel) selectedLabel.textContent = field.dataset.selectedValue;

      if (field.dataset.pickerField !== "radio") return;

      field.querySelectorAll(".m-product-option--node__label[data-selected=true]").forEach((label) => {
        label.removeAttribute("data-selected");
      });

      const label = Array.from(field.querySelectorAll(".m-product-option--node__label")).find((label) => label.htmlFor === target.id);
      if (label) label.dataset.selected = "true";
    }
  }
  customElements.define("variant-picker", VariantPicker);
}
